import React from 'react';

import { redirectUser } from '../authentication';
import TokenVerification from '../TokenViews/TokenVerification';
import { getRedirectToLink } from './getRedirectLink';
import { useParams } from 'react-router';

export type LoginSuccessPayload = {
  data: { next?: string; state_key: string };
};
const LoginTokenVerification = () => {
  const { token } = useParams();

  return (
    <TokenVerification<LoginSuccessPayload>
      token={token || ''}
      verificationUrl="/api/lending/edge/passwordless/email/login/"
      requestNewTokenUrl="/login/passwordless/email"
      onSuccess={(payload) =>
        redirectUser({
          redirectUrl: getRedirectToLink() || payload?.data?.next,
        })
      }
    />
  );
};

export default LoginTokenVerification;
